import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Analytics — loads Google Analytics 4 if REACT_APP_GA4_MEASUREMENT_ID is set.
 *
 * Note: Plausible is loaded directly in public/index.html via the official
 * v2 snippet — no dynamic injection here to avoid double-tracking.
 *
 * Enable Google Analytics 4: set REACT_APP_GA4_MEASUREMENT_ID (e.g. "G-XXXXXXXXXX")
 *   - Free, more data, but sets cookies — add a consent banner in EU/UK
 *
 * If GA4 var isn't set, this component is a no-op — zero perf cost.
 */
export default function Analytics() {
  const ga4Id = (process.env.REACT_APP_GA4_MEASUREMENT_ID || "").trim();
  const location = useLocation();

  // One-time GA4 script injection
  useEffect(() => {
    if (ga4Id && !document.getElementById("ga4-script")) {
      const s = document.createElement("script");
      s.id = "ga4-script";
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${ga4Id}`;
      document.head.appendChild(s);
      const inline = document.createElement("script");
      inline.id = "ga4-inline";
      inline.text = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', '${ga4Id}', { send_page_view: false });
      `;
      document.head.appendChild(inline);
    }
  }, [ga4Id]);

  // SPA page-view tracking on every route change
  useEffect(() => {
    const path = location.pathname + location.search;
    if (ga4Id && window.gtag) {
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
    // Plausible v2 tracker (loaded in index.html) auto-tracks SPA route changes
    // via History API — no manual call needed here.
  }, [location, ga4Id]);

  return null;
}
